import { render, staticRenderFns } from "./ListFormationPage.vue?vue&type=template&id=320e9c15"
import script from "./ListFormationPage.vue?vue&type=script&lang=js"
export * from "./ListFormationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports